import React from 'react'

function ServiceL2() {
  return (
    <>
      <section>
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-12 col-lg-5 mb-5 mb-lg-0">
              <div className="mb-5">
                <h2><span className="font-w-4 d-block">That's right for</span> you and your team</h2>
                <p className="lead mb-0">We use the latest technologies it voluptatem accusantium doloremque laudantium.</p>
              </div>
              <div className="accordion" id="accordion">
                <div className="accordion-item rounded mb-2">
                  <h2 className="accordion-header" id="headingOne">
                    <button className="accordion-button border-0 mb-0 bg-transparent" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      When our power of choice EPICFINAL ?
                    </button>
                  </h2>
                  <div id="collapseOne" className="accordion-collapse border-0 collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">
                    <div className="accordion-body text-muted">Looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites and web page editors.</div>
                  </div>
                </div>
                <div className="accordion-item rounded mb-2">
                  <h2 className="accordion-header" id="headingTwo">
                    <button className="accordion-button border-0 mb-0 bg-transparent collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      Nam libero tempore, cum soluta nobis ?
                    </button>
                  </h2>
                  <div id="collapseTwo" className="accordion-collapse border-0 collapse" aria-labelledby="headingTwo" data-bs-parent="#accordion">
                    <div className="accordion-body text-muted">Looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites and web page editors.</div>
                  </div>
                </div>
                <div className="accordion-item rounded">
                  <h2 className="accordion-header" id="headingThree">
                    <button className="accordion-button border-0 mb-0 bg-transparent collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      which is the same as saying through ?
                    </button>
                  </h2>
                  <div id="collapseThree" className="accordion-collapse border-0 collapse" aria-labelledby="headingThree" data-bs-parent="#accordion">
                    <div className="accordion-body text-muted">Looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites and web page editors.</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="row">
                <div className="col-md-6">
                  <div className="p-4 rounded shadow">
                    <div className="bg-primary p-2 d-inline-block rounded">
                      <div className="f-icon-m text-white"> <i className="flaticon-lightbulb"></i>
                      </div>
                    </div>
                    <h5 className="mt-4 mb-3">Easy To Use</h5>
                    <p className="mb-0">Taking design from EPICFINAL design and typography, contemporary page layouts.</p>
                  </div>
                </div>
                <div className="col-md-6 mt-5">
                  <div className="p-4 rounded shadow">
                    <div className="bg-primary p-2 d-inline-block rounded">
                      <div className="f-icon-m text-white"> <i className="flaticon-migrating"></i>
                      </div>
                    </div>
                    <h5 className="mt-4 mb-3">Cloud Migration</h5>
                    <p className="mb-0">Taking design from EPICFINAL design and typography, contemporary page layouts.</p>
                  </div>
                </div>
                <div className="col-md-6 mt-5 mt-md-0">
                  <div className="p-4 rounded shadow">
                    <div className="bg-primary p-2 d-inline-block rounded">
                      <div className="f-icon-m text-white"> <i className="flaticon-graphs"></i>
                      </div>
                    </div>
                    <h5 className="mt-4 mb-3">Data Analysis</h5>
                    <p className="mb-0">Taking design from EPICFINAL design and typography, contemporary page layouts.</p>
                  </div>
                </div>
                <div className="col-md-6 mt-5">
                  <div className="p-4 rounded shadow">
                    <div className="bg-primary p-2 d-inline-block rounded">
                      <div className="f-icon-m text-white"> <i className="flaticon-3d-modeling"></i>
                      </div>
                    </div>
                    <h5 className="mt-4 mb-3">Software Design</h5>
                    <p className="mb-0">Taking design from EPICFINAL design and typography, contemporary page layouts.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ServiceL2
